import './TemplateDropdown.css';
import PRESET_TEMPLATES from '../prompts/preset_templates.js';

const templateOptions = PRESET_TEMPLATES.map(template => template.prompt_name);

const TemplateDropdown = ({ selectedTemplate, setSelectedTemplate, isTemplateConfirmed, setIsTemplateConfirmed, handleSetPromptTemplate }) => {
    
    const handleChange = (e) => {
        const value = e.target.value;
        setSelectedTemplate(value);
        setIsTemplateConfirmed(false);
    };

    const handleGetTemplate = () => {
        setIsTemplateConfirmed(true);
        const selectedTemplateObject = PRESET_TEMPLATES.find(template => template.prompt_name === selectedTemplate);
        handleSetPromptTemplate(selectedTemplateObject.prompt);
    };

    return (
        <div className="template-dropdown-container">
            <label className="template-label">Choose a Template</label>
            <p className="template-description">Pick a template or create a custom request.</p>
            <div className="template-select-container">
                <div className="template-select-wrapper">
                    <select 
                        value={selectedTemplate} 
                        onChange={handleChange}
                        className="template-select"
                    >
                        <option value="">-- Select Template --</option>
                        {templateOptions.map((option, index) => (
                            <option key={index} value={option}>{option}</option>
                        ))}
                    </select>
                    <span className="dropdown-icon">▼</span>
                </div>
                {!isTemplateConfirmed && (
                    <button 
                        className="get-template-button"
                        onClick={handleGetTemplate}
                        disabled={!selectedTemplate}
                    >
                        Get Template
                    </button>
                )}
            </div>
        </div>
    );
};

export default TemplateDropdown;
